/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import messages from '@modules/ccm-admin-components/messages'
import type { AdminConsoleCCMCluster } from '@modules/ccm-admin-lib/types'
import DestructiveActionConfirmationModal from '@modules/cui/ConfirmationModal'

import type { FC } from 'react'

export const DisconnectClusterModal: FC<{
  disconnectingCluster: AdminConsoleCCMCluster
  onConfirm: () => void
  onCancel: () => void
}> = ({ disconnectingCluster, onConfirm, onCancel }) => {
  const { formatMessage } = useIntl()

  const copyToClipboardMessage = formatMessage(messages.copyToClipboardMessage)

  return (
    <DestructiveActionConfirmationModal
      modalTitle={formatMessage(messages.disconnectModalTitle)}
      resourceName={disconnectingCluster.name || disconnectingCluster.self_managed_cluster.id}
      onCloseConfirmModal={onCancel}
      onDeleteButtonConfirm={onConfirm}
      nameToConfirmFormRowLabel={formatMessage(messages.nameToConfirmFormRowLabel)}
      copyToClipboardMessage={copyToClipboardMessage}
      cancelButtonLabel={formatMessage(messages.modalCancelButton)}
      deleteButtonLabel={formatMessage(messages.deleteButtonLabel)}
      getMistypedResourceNameErrorMessage={(resourceName: string) =>
        formatMessage(messages.mistypedResourceNameError, { name: resourceName })
      }
      calloutTitle={formatMessage(messages.modalCalloutTitle)}
      getCalloutMessage={(resourceName: React.ReactNode) =>
        formatMessage(messages.modalCalloutMessage, { name: resourceName })
      }
    />
  )
}
